import React from "react";
import { Modal } from "reactstrap";
import ReferralForm from "./CreateInvoiceForm";

const EditReferralModal = ({ program, isOpen, setOpen, toggle, referral }) => {
  const props = { toggle, referral, program };

  return (
    <Modal
      className="program-settings modal-2col modal-lg"
      isOpen={isOpen}
      toggle={() => setOpen(true)}
    >
      <div className="left">
        <div className="modal-2col__left-head">
          <span className="modal-2col__eyebrow">Referral</span>
          <h3 className="modal-2col__title">Edit Referral</h3>
          {referral?.referral_notification_recipient_email && (
            <p className="modal-2col__description">
              {referral.referral_notification_recipient_email}
            </p>
          )}
        </div>
      </div>

      <div className="right">
        <button type="button" className="modal-2col__close" onClick={toggle} aria-label="Close">
          Close
        </button>
        <ReferralForm {...props} />
      </div>
    </Modal>
  );
};

export default EditReferralModal;
